import urls from 'constants/urls';
import {
  SHOP_BY_LIST_VIEW_ALL_MODAL_ID,
  SHOP_BY_LIST_VIEW_ALL_MODAL_NAME,
  SHOP_BY_LIST_VIEW_ALL_CTA_LABEL,
  SHOP_BY_LIST_FORM_SUBMIT_CTA_LABEL,
  SHOP_BY_LIST_UPLOAD_IMAGE_CTA_LABEL,
  SHOP_BY_LIST_TAKE_A_PHOTO_CTA_LABEL,
} from 'components/ShopByListPage/constants';
import { SHOP_BY_LIST_CTA_TEXT } from 'components/ShopByListCta/constants';
import { FEATURE_CTA_EVENT_TYPE, trackFeatureCta } from './feature-cta-tracking';
import { FEATURE_ELEMENT_EVENT_TYPE, trackFeatureElement } from './feature-element-tracking';
import { trackClickInteraction } from './click-interaction-tracking';
import { trackInfoLoaded } from './info-loaded-tracking';
import { dataLayer } from './data-layer';

export const FEATURE_SHOP_BY_LIST = 'list_to_basket';

export function trackShopByListCtaImpression() {
  return trackFeatureCta({
    eventType: FEATURE_CTA_EVENT_TYPE.IMPRESSION,
    feature: FEATURE_SHOP_BY_LIST,
    featureCtaId: 'search_box_list_to_basket',
    linkText: SHOP_BY_LIST_CTA_TEXT,
    linkUrl: urls.shopByList,
  });
}

export function trackShopByListCtaClick() {
  return trackFeatureCta({
    eventType: FEATURE_CTA_EVENT_TYPE.CLICK,
    feature: FEATURE_SHOP_BY_LIST,
    featureCtaId: 'search_box_list_to_basket',
    linkText: SHOP_BY_LIST_CTA_TEXT,
    linkUrl: urls.shopByList,
  });
}

export function trackShopByListTooltipImpression() {
  return trackFeatureElement({
    eventType: FEATURE_ELEMENT_EVENT_TYPE.IMPRESSION,
    feature: FEATURE_SHOP_BY_LIST,
    featureElement: 'search_box_list_to_basket_tool_tip',
    classification: 'view_tool_tip',
  });
}

export function trackShopByListTooltipDismissal() {
  return trackFeatureElement({
    eventType: FEATURE_ELEMENT_EVENT_TYPE.CLICK,
    feature: FEATURE_SHOP_BY_LIST,
    featureElement: 'search_box_list_to_basket_tool_tip',
    classification: 'dismiss_tool_tip',
  });
}

export function trackTextAreaClick() {
  return trackClickInteraction({ classification: 'text_area_click' });
}

export function trackTakeAPhotoClick() {
  return trackClickInteraction({
    classification: 'use_camera_click',
    linkText: SHOP_BY_LIST_TAKE_A_PHOTO_CTA_LABEL,
  });
}

export function trackUploadImageClick() {
  return trackClickInteraction({
    classification: 'upload_image_click',
    linkText: SHOP_BY_LIST_UPLOAD_IMAGE_CTA_LABEL,
  });
}

export function trackFormSubmitClick() {
  return trackClickInteraction({
    classification: 'shop_with_list_click',
    linkText: SHOP_BY_LIST_FORM_SUBMIT_CTA_LABEL,
  });
}

export function trackTextAreaTypedInfoLoaded() {
  return trackInfoLoaded({
    classification: 'text_typed',
  });
}

export function trackTextAreaPastedInfoLoaded() {
  return trackInfoLoaded({
    classification: 'text_pasted',
  });
}

export function trackUploadImageInfoLoaded() {
  return trackInfoLoaded({
    classification: 'file_upload',
  });
}

export function trackEditCtaClick({
  editCtaLabel,
  searchTerm,
}: {
  editCtaLabel: string;
  searchTerm: string;
}) {
  return trackClickInteraction({
    classification: `edit_${searchTerm}`,
    linkText: editCtaLabel,
  });
}

export function trackAddCtaClick({
  addCtaLabel,
  searchTerm,
}: {
  addCtaLabel: string;
  searchTerm: string;
}) {
  return trackClickInteraction({
    classification: `add_${searchTerm}`,
    linkText: addCtaLabel,
  });
}

export function trackViewAllClick({ searchTerm }: { searchTerm: string }) {
  return trackClickInteraction({
    classification: `view_all_${searchTerm}`,
    linkText: SHOP_BY_LIST_VIEW_ALL_CTA_LABEL,
  });
}

export function trackAddAllCtaClick({ addAllCtaLabel }: { addAllCtaLabel: string }) {
  return trackClickInteraction({
    classification: 'add_all_to_cart',
    linkText: addAllCtaLabel,
  });
}

export function trackViewAllModalOpened({ title }: { title: string }) {
  dataLayer.push({
    event: 'open_modal',
    modal_name: SHOP_BY_LIST_VIEW_ALL_MODAL_NAME,
    action: SHOP_BY_LIST_VIEW_ALL_CTA_LABEL,
    id: SHOP_BY_LIST_VIEW_ALL_MODAL_ID,
    title,
  });
}

export function trackViewAllModalClosed({ title }: { title: string }) {
  dataLayer.push({
    event: 'close_modal',
    modal_name: SHOP_BY_LIST_VIEW_ALL_MODAL_NAME,
    action: SHOP_BY_LIST_VIEW_ALL_CTA_LABEL,
    id: SHOP_BY_LIST_VIEW_ALL_MODAL_ID,
    title,
  });
}
